import { todayTasks } from "@/mocks/dashboard";

const colorMap: Record<string, { bg: string; text: string; num: string; border: string }> = {
  amber: { bg: "bg-amber-50", text: "text-amber-700", num: "text-amber-600", border: "border-amber-200" },
  sky: { bg: "bg-sky-50", text: "text-sky-700", num: "text-sky-600", border: "border-sky-200" },
  orange: { bg: "bg-orange-50", text: "text-orange-700", num: "text-orange-600", border: "border-orange-200" },
  emerald: { bg: "bg-emerald-50", text: "text-emerald-700", num: "text-emerald-600", border: "border-emerald-200" },
};

const iconMap: Record<string, string> = {
  payment: "ri-money-cny-circle-line",
  tomorrow: "ri-calendar-todo-line",
  commitment: "ri-file-list-3-line",
  referral: "ri-user-add-line",
};

export default function TodayTasks() {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
      <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-calendar-check-line text-base text-gray-600"></i>
          </div>
          <h3 className="font-semibold text-gray-900 text-sm">Bugünün Görevleri</h3>
        </div>
        <span className="text-xs text-gray-400">19 Mayıs 2026</span>
      </div>
      <div className="divide-y divide-gray-50">
        {todayTasks.map((task, i) => {
          const c = colorMap[task.color] || colorMap.emerald;
          return (
            <div key={i} className={`flex items-center gap-4 px-5 py-3.5 hover:bg-gray-50/50 transition-colors cursor-pointer`}>
              <div className={`w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0 ${c.bg} border ${c.border}`}>
                <i className={`${iconMap[task.type]} text-base ${c.num}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-700">{task.text}</p>
              </div>
              <div className={`flex-shrink-0 text-xl font-bold ${c.num}`}>
                {task.count}
              </div>
              <div className="w-5 h-5 flex items-center justify-center text-gray-300">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}